import type { GetServerSideProps } from 'next';
import type { MedicalConditionsPageProps } from 'lib/queries/conditions';
import { Wrap } from '@leafwell/components';
import PageWrap from 'components/page-wrap';
import HeroConditions from 'components/hero-conditions';
import WysiwygContent from 'components/wysiwyg-content';
import ArticleJson from 'components/structured-data/article';
import { getMedicalConditionsPage } from 'lib/queries/conditions';
//import ConditionsAlphabetical from 'components/conditions-alphabetical';
import ConditionsByType from 'components/conditions-by-type';

/* export const getStaticProps = async context =>
  await getMedicalConditionsPage(context); */

export const getServerSideProps = (async context => {
  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59',
  );

  return await getMedicalConditionsPage(context);
}) satisfies GetServerSideProps<MedicalConditionsPageProps>;

export default function MedicalConditions(props: MedicalConditionsPageProps) {
  const {
    page: {
      id,
      title,
      content,
      date,
      modified,
      seo,
      acf: { hero, pageType },
    },
    //conditionsList,
    conditionsByType: { conditions, pagination, conditionType },
    conditionsType,
  } = props;

  return (
    <PageWrap seo={seo} pageType={pageType} title={title}>
      <ArticleJson id={id} date={date} modified={modified} seo={seo} />
      <HeroConditions
        title={hero.title}
        subTitle={hero.subTitle}
        image={hero.image}
      />
      {content ? (
        <Wrap size="small" className="justify-items-center">
          <WysiwygContent className="w-full max-w-2xl" content={content} />
        </Wrap>
      ) : null}
      {/* <ConditionsAlphabetical conditions={conditionsList} /> */}
      <Wrap className="relative !mb-0 !pb-0">
        <ConditionsByType
          className="lg:col-span-full"
          conditionTypes={conditionsType}
          conditions={conditions}
          pagination={pagination}
          conditionType={conditionType}
        />
      </Wrap>
    </PageWrap>
  );
}
